/**
 * MIRROR of the SERVER's isRestrictedClinicUser (backend src/common/tenancy.util.ts). Keep the two
 * in LOCKSTEP - the admin screen must show the ENFORCED access level, never the fail-open opposite.
 *
 * A naive `clinicRole === 'user'` in the UI renders a stored 'User' (a migration typo
 * the server correctly RESTRICTS) as "Owner", and the admin's next Save would then genuinely widen
 * the account. Rule, same as the server: OWNER iff clinicRole is absent/null/blank or 'owner' (any
 * casing); ANY other present value - including a non-string - is a restricted USER (fail-safe).
 */
export function isRestrictedClinicUser(clinicRole) {
  if (clinicRole === null || clinicRole === undefined) return false; // absent => owner
  if (typeof clinicRole !== 'string') return true; // anomalous non-string => restrict (fail-safe)
  const v = clinicRole.trim().toLowerCase();
  if (v === '' || v === 'owner') return false;
  return true;
}

/** The dropdown value ('owner' | 'user') for a stored clinicRole, matching enforcement. */
export function clinicRoleSelectValue(clinicRole) {
  return isRestrictedClinicUser(clinicRole) ? 'user' : 'owner';
}
